import { wpBaseURL } from '$lib/api';
import { error } from '@sveltejs/kit';
import type { WP_REST_API_Posts } from 'wp-types';

export async function load({ params: { id, type }, setHeaders }) {
	const url = `${wpBaseURL}posts?${type === 'author' ? type : 'categories'}=${id}&_fields=excerpt.rendered,title,slug,id,_links.author,_embedded&_embed`;
	const response = await fetch(url);
	const posts = (await response.json()) as WP_REST_API_Posts
	if (!posts.length) throw error(404);

	setHeaders({
		'Cache-Control': 'public, max-age=3600',
	});

	const obj = await fetch(`${wpBaseURL}${type === 'author' ? type : 'categories'}/${id}`).then((r) => r.json())

	if (!obj.name) {
		x: for (let post of posts) {
			for (let author of post._embedded.author) {
				if (author.id == id) {
					obj.name = author.name.split(/,\s|és/).at(0).trim();
					break x;
				}
			}
		}
	}

	return {
		posts,
		id,
		obj
	};
}

export const prerender = 'auto'